import { PlaceDirections } from "../../../google/PlaceDirections";

export enum TaxiCompanyList {
  /** イースタン交通 */
  limoTaxi = 'limoTaxi',
  eastern = 'eastern',
  /** 宮交タクシー */
  miyakou = 'miyakou',
  /** 宇部山電タクシー */
  ubeSanden = 'ubeSanden',
  /** 那覇ハイヤー */
  nahahire = 'nahahire',
  /** 日ノ丸ハイヤー */
  hinomaru = 'hinomaru',
  /** 伊予鉄タクシー */
  iyotetsutaxi = 'iyotetsutaxi',
  /** 伊予鉄タクシー（メーター料金） */
  iyotetsuTaxi2 = 'iyotetsuTaxi2',
  /** 大分別府合同タクシー */
  gotaku = 'gotaku',
  /** 旭川中央タクシー */
  Asahikawachuuo = 'Asahikawachuuo',
  /** 函館タクシー */
  hakodateTaxi = 'hakodateTaxi',
  /** 大和自動車交通 */
  daiwaj = 'daiwaj',
  /** 北福島タクシー */
  kitafukushima = 'kitafukushima',
  /** 中央タクシー */
  fukushimachuo = 'fukushimachuo',
  /** 磐城タクシー */
  iwakiTaxi = 'iwakiTaxi',
  /** 内郷タクシー */
  'uchi-go' = 'uchi-go',
  /** 田島タクシー */
  tajimaTaxi = 'tajimaTaxi',
  /** 鬼怒川タクシー */
  kinugawaTaxi = 'kinugawaTaxi',
  /** 北斗交通 */
  hokutocab = 'hokutocab',
  /** 陽東タクシー */
  yotoTaxi = 'yotoTaxi',
  /** キングタクシー */
  kingTaxi = 'kingTaxi',
  /** 土電タクシー */
  toden = 'toden',
  /** 石川交通 */
  ishikawakotsu = 'ishikawakotsu',
  /** キングタクシー（メーター料金） */
  kingTaxi2 = 'kingTaxi2',
  /** 宇部構内タクシー */
  ubeKounai = 'ubeKounai',
  /** 通津タクシー */
  tsuzutaxi = 'tsuzutaxi',
  /** 酒田タクシー */
  sakataNo1Taxi = 'sakataNo1Taxi',
  /** 庄交ハイヤー */
  shokoHire = 'shokoHire',
  /** 秋田エアポートライナー */
  airport_liner = 'airport_liner',
  /** にかほGO */
  nikaho_go = 'nikaho_go',
  /** 稲荷タクシー */
  inari = 'inari',
  /** 稲荷タクシー（高速料金） */
  inarihw = 'inarihw',
  /** 網走ハイヤー */
  abashiri = 'abashiri',
  /** つばめタクシー */
  tsubame = 'tsubame',
  /** つばめハイヤー */
  tsubamelimo = 'tsubamelimo',
  /** 北鹿観光ハイヤー */
  hokuroku = 'hokuroku',
  /** 検証用ダミータクシー会社 */
  dummyVal = 'dummyVal'
}

// 文字列から TaxiCompanyList に変換する
export const convertStringToTaxiCompany = ((companyString: string)=>{
  switch(companyString) {
    case TaxiCompanyList.limoTaxi:
      return TaxiCompanyList.limoTaxi;
    case TaxiCompanyList.eastern:
      return TaxiCompanyList.eastern;
    case TaxiCompanyList.miyakou:
      return TaxiCompanyList.miyakou;
    case TaxiCompanyList.ubeSanden:
      return TaxiCompanyList.ubeSanden;
    case TaxiCompanyList.nahahire:
      return TaxiCompanyList.nahahire;
    case TaxiCompanyList.hinomaru:
      return TaxiCompanyList.hinomaru;
    case TaxiCompanyList.iyotetsutaxi:
      return TaxiCompanyList.iyotetsutaxi;
    case TaxiCompanyList.iyotetsuTaxi2:
      return TaxiCompanyList.iyotetsuTaxi2;
    case TaxiCompanyList.gotaku:
      return TaxiCompanyList.gotaku;
    case TaxiCompanyList.Asahikawachuuo:
      return TaxiCompanyList.Asahikawachuuo;
    case TaxiCompanyList.hakodateTaxi:
      return TaxiCompanyList.hakodateTaxi;
    case TaxiCompanyList.daiwaj:
      return TaxiCompanyList.daiwaj;
    case TaxiCompanyList.kitafukushima:
      return TaxiCompanyList.kitafukushima;
    case TaxiCompanyList.fukushimachuo:
      return TaxiCompanyList.fukushimachuo;
    case TaxiCompanyList.iwakiTaxi:
      return TaxiCompanyList.iwakiTaxi;
    case TaxiCompanyList['uchi-go']:
      return TaxiCompanyList['uchi-go'];
    case TaxiCompanyList.tajimaTaxi:
      return TaxiCompanyList.tajimaTaxi;
    case TaxiCompanyList.kinugawaTaxi:
      return TaxiCompanyList.kinugawaTaxi;
    case TaxiCompanyList.hokutocab:
      return TaxiCompanyList.hokutocab;
    case TaxiCompanyList.yotoTaxi:
      return TaxiCompanyList.yotoTaxi;
    case TaxiCompanyList.kingTaxi:
      return TaxiCompanyList.kingTaxi;
    case TaxiCompanyList.toden:
      return TaxiCompanyList.toden;
    case TaxiCompanyList.ishikawakotsu:
      return TaxiCompanyList.ishikawakotsu;
    case TaxiCompanyList.dummyVal:
      return TaxiCompanyList.dummyVal;
    case TaxiCompanyList.tsuzutaxi:
      return TaxiCompanyList.tsuzutaxi;
    case TaxiCompanyList.kingTaxi2:
      return TaxiCompanyList.kingTaxi2;
    case TaxiCompanyList.ubeKounai:
      return TaxiCompanyList.ubeKounai;
    case TaxiCompanyList.sakataNo1Taxi:
      return TaxiCompanyList.sakataNo1Taxi;
    case TaxiCompanyList.shokoHire:
      return TaxiCompanyList.shokoHire;
    case TaxiCompanyList.airport_liner:
      return TaxiCompanyList.airport_liner;
    case TaxiCompanyList.nikaho_go:
      return TaxiCompanyList.nikaho_go;
    case TaxiCompanyList.inari:
      return TaxiCompanyList.inari;
    case TaxiCompanyList.inarihw:
      return TaxiCompanyList.inarihw;
    case TaxiCompanyList.abashiri:
      return TaxiCompanyList.abashiri;
    case TaxiCompanyList.tsubame:
      return TaxiCompanyList.tsubame;
    case TaxiCompanyList.tsubamelimo:
      return TaxiCompanyList.tsubamelimo;
    case TaxiCompanyList.hokuroku:
      return TaxiCompanyList.hokuroku;
    default:
      return null;
  }
})

/**
 * 指定した会社が福島タクシー群かを判定する
 * @param company 判定対象のタクシー会社
 * @returns 指定した会社が福島タクシー群かを
 */
export const isFukushimaTaxi = ((company: TaxiCompanyList) => {
  const fukushimaTaxisList = [
    TaxiCompanyList.daiwaj,
    TaxiCompanyList.kitafukushima,
    TaxiCompanyList.fukushimachuo,
    TaxiCompanyList.iwakiTaxi,
    TaxiCompanyList['uchi-go'],
    TaxiCompanyList.tajimaTaxi,
    TaxiCompanyList.kinugawaTaxi,
    TaxiCompanyList.hokutocab,
    TaxiCompanyList.yotoTaxi
  ]
  return fukushimaTaxisList.includes(company);
})

export enum GetDirectionAndFareOperation {
  pickup = 'pickup',
  dropOff = 'dropOff'
}

export enum FlightType {
  // 国内線
  domestic = 'domestic',
  // 国際線
  international = 'international'
}

export interface PointInfo {
  /** 表示用地点座標。乗車地であるか降車地であるかはoperationパラメータに依存する。 */
  latLng: string,
  /** 表示用地点名。乗車地であるか降車地であるかはoperationパラメータに依存する。 */
  label: string,
  /** 料金計算用地点座標。乗車地であるか降車地であるかはoperationパラメータに依存する。 */
  latLngForPriceCalc: string,
  /** 料金計算用地点名。乗車地であるか降車地であるかはoperationパラメータに依存する。タリフのマッチングは日本語で行うため、英語版でもここは必ず日本語住所が設定される */
  labelForPriceCalc: string
}

/**
 * タクシー料金APIのリクエストパラメーターの共通部分
 */
interface CommonTaxiAPIParams {
  // ユーザー指定地点情報
  pointInfo?: PointInfo,
  // 空港コード
  airportLetter: string,
  // 出発案内か
  operation: GetDirectionAndFareOperation,
  // 補助値
  mode?: string,
  // 補助値
  modeValue?: string,
  // 国内・国際の区別
  flightType?: FlightType,
  // ターミナル情報
  terminal?: string,
  // 乗降口
  gate?: string,
}

/**
 * 仮予約画面にて使用するタクシー料金APIのリクエストパラメーター
 */
export interface GetDirectionAndFareParams extends CommonTaxiAPIParams {
  // 事業者コード
  companyCode: TaxiCompanyList,
  // 乗車日時：yyyyMMddhhmm 形式
  rideDatetime: string;
  // 予約操作時刻：yyyyMMddhhmm 形式
  reservationDatetime?: string;
  // 言語情報
  language: string
}

/**
 * 経路検索画面にて使用するタクシー料金APIのリクエストパラメーター
 */
export interface GetDirectionAndFareSamplesParams extends CommonTaxiAPIParams {
  // 結果にGoogle Directions APIのpolylineを付与するかどうか
  needPolyline: boolean,
  // 乗車日時: unixtime
  datetimeAtAirport: number,
  // 言語情報
  language: string
}

/**
 * 経路検索結果画面でのResponseFormat
 */
export interface GetDirectionAndFareSamplesResponse {
  routeInfo: RouteInfo;
  existMatchedCompany: boolean,
  fareSummaries: TaxiFareSummary[],
  directionsApiResponse: PlaceDirections
}

export interface RouteInfo {
  /** 距離ラベル */
  distanceLabel: string,
  /** 所要時間ラベル */
  durationLabel: string,
  /** 距離(m) */
  distanceValue: number,
  /** 所要時間(s) */
  durationValue: number
}

export interface TaxiFareSummary {
  mode: string;
  companyCode: TaxiCompanyList,
  fareInfo: GetDirectionAndFareResponse
}

/**
 * 仮予約画面で使用するタクシー料金APIのResponse
 */
export interface GetDirectionAndFareResponse {
  status: string,
  notesLabel: string[],
  alertLabel: AlertLabel[],
  fareType: string,
  // 廃止予定
  value: number,
  // 廃止予定
  totalValue: number,
  // 廃止予定
  distance: number,
  // 廃止予定
  duration: number,
  fareLabel: string,
  distanceLabel: string,
  durationLabel: string,
  timePattern?: string[],
  flightPattern?: string[]
}

export interface AlertLabel {
  type: string,
  message: string
}
